<!-- YuHongYou -->
<template>
<div class="patrolManagement">
  <seeqr-code v-if="showQrcode" :showQrcode="showQrcode" @closeQrcode="closeQc" :qrcodeDatas="qrcodeDatas"></seeqr-code>
  <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <patrol-point-drawer v-if="drawerShow" :editData="selectData" :handleType="handleType" :loading.sync="loading" :selectZoneList="selectZoneList" :deptOptions="deptOptions" @confirm="handleConfirm" @cancel="handleCancel"></patrol-point-drawer>
  </el-drawer>
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <span>
        <el-select v-model="relatedDeptId" placeholder="所在部门">
          <el-option
            v-for="item in deptOptions"
            :key="item.id"
            :label="item.deptName"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="names" autocomplete="off" placeholder="请输入巡检点名称"></el-input>
        <button v-if="rolePermit('polling:point:query')" class="primaryBtn" @click="serachData">查询</button>
      </span>
      <button v-if="rolePermit('polling:point:add')" class="primaryBtn" @click="addClick">新增巡查点</button>
      <button class="primaryBtn" @click="seeQrcode()">预览二维码</button>
    </div>
    <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" @selectionChange="handleSelectionChange" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
      <el-table-column type="selection" width="50" border></el-table-column>
      <!-- <el-table-column type="index" width="55" label="序号"></el-table-column> -->
      <el-table-column prop="pollPointId" label="巡检编号" />
      <el-table-column prop="pointName" label="巡检点名称" />
      <el-table-column prop="deptName" label="所在部门" />
      <el-table-column prop="deptHeadName" label="负责人" />
      <el-table-column prop="position" label="具体位置" />
      <el-table-column prop="address" label="详细位置" />
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column prop="" label="巡检设备类型">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.detailInfoDtos" :key="index">
            <span>{{item.pointTypeName}}</span><span>{{(index+1)==scope.row.detailInfoDtos.length?'':','}}</span>
          </span>
        </template>
     </el-table-column>
      <el-table-column prop="" label="操作" width="120" v-if="rolePermit('polling:point:add')||rolePermit('polling:point:del')">
        <template slot-scope="scope">
          <el-button v-if="rolePermit('polling:point:add')" @click="editClick(scope.row)" size="small" class="edit">编辑</el-button>
          <el-button v-if="rolePermit('polling:point:del')" @click="delClick(scope.row)" size="small" class="del">删除</el-button>
        </template>
      </el-table-column>
    </border-table>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import PatrolPointDrawer from "@/components/patrolManagement/PatrolPointDrawer";
import SeeqrCode from "@/components/patrolManagement/SeeqrCode";

export default {
  components: {
    BorderTable,
    PatrolPointDrawer,
    SeeqrCode
  },
  data() {
    return {
      showQrcode: false,
      radio: "1",
      names: "",
      relatedDeptId: "",
      deptOptions: [],
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      selectZoneList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      drawerTitle: "",
      drawerWidth: "500px",
      handleType: '',
      selectData: {},
      checkDatas: [],
      qrcodeDatas: []
    };
  },
  created() {
    this.makeheight()
    this.initData()
    this.queryDeptOptions()
  },
  methods: {
     //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    /**
     * @Description 请求所在部门
     * @Author      YOYO     -             2022-11-09
     */
    queryDeptOptions() {
      this.request.get("/front/polling/point/getRelatedDeptInfo")
        .then(rs => {
          if (rs.code == 200) {
            console.log(rs)
            this.deptOptions = rs.data || []
          } else {
            this.deptOptions = []
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    initData () {
      this.addNewPoint()
    },
    //模糊查询
    initPoint () {
      this.selectData = {}
      let params = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        // tenantId: '123456',
        pointName: this.names, //巡检点名称
        relatedDeptId: this.relatedDeptId, //关联部门
      }
      this.request.get('/front/polling/point/getPonintLike', params).then(res => {
        // console.log(res)
        if (res.code == 200) {
          this.dataList = res.data.pageData
          this.pagination.total = res.data.total;
        } else if (res.code == 500) {
          this.msg.warn(res.msg)
		      this.dataList =[]
        }
      })
    },
    //巡查点列表
    addNewPoint() {
      this.selectData = {}
      let params = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        // tenantId: '123456',
      }
      this.request.get('/front/polling/point/getALLPonintTypeInfo', params).then(res => {
        if (res.code == 200) {
          this.dataList = res.data.pageData
          this.pagination.total = res.data.total;
        } else if (res.code == 500) {
          this.msg.warn(res.msg)
    		  this.dataList =[]
        }
      })
    },
    serachData() {
      //查询//搜索
      if (this.names=='' && this.relatedDeptId == '') {
        this.initData()
      } else {
        this.names = this.names.replace(/(^\s*)|(\s*$)/g, "");
        this.pagination.currentPage = 1;
        this.initPoint();
      }
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.initPoint();
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.initPoint();
    },
    editClick(row) {
      //编辑
      this.selectData = row
      this.drawerShow = true;
      this.drawerTitle = "编辑巡查点";
      this.handleType = "edit";
      // this.$store.commit("saveCurrDbSource", "编辑巡查点");
      // this.userId=row.id
    },
    delClick(row) {
      let params={
        tenantId:"123456",
    		pointId:row.pointId,
        pointName:row.pointName
      }
      //删除
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.postParamsData("/front/polling/point/delAllByPoint",params).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              let num = ''
              if (this.pagination.total > 1) {
                num = (this.pagination.total - 1) % this.pagination.pageSize
                if (num == 0) {
                  this.pagination.currentPage = this.pagination.currentPage - 1
                }
              }
              this.initData()
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    detailClick(row) { //详情

    },
    addClick(type) {
      //新增
      // this.backInit()
      this.drawerShow = true;
      this.drawerTitle = "新增巡查点";
      this.handleType = 'add';
      // console.log(this.dataList);
      this.selectZoneList = []
      // this.dataList.forEach(val => {
      //   this.selectZoneList.push(val.zoneId);
      // })
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    handleConfirm(data) { //确认
      // console.log(data)
      if (this.handleType=='add') {
        let params = Object.assign(data,{pointId:null})
        //保存页面巡检项信息
        this.request.post("/front/polling/point/addPointInfo", params).then(res => {
          if (res.code == 200) {
            this.msg.success("添加成功")
          } else {
            this.msg.warn(res.msg)
          }
          this.initData()
        }).catch(error => {
          console.log(error)
        });
      } else if (this.handleType=='edit') {
          //保存页面巡检项信息
          let params=Object.assign(data,{ pointId:this.selectData.pointId })
          this.request.post("/front/polling/point/addPointInfo", params).then(res => {
            if (res.code == 200) {
              this.msg.success("编辑成功")
            } else {
              this.msg.warn("编辑失败")
            }
            this.initData()
          }).catch(error => {
            console.log(error)
          });
      }
      this.drawerShow = false;
    },
    handleCancel(data) { //取消
      // console.log(data)
      this.drawerShow = false
    },
    seeQrcode() { //二维码查看
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选巡查点！")
      } else if (this.checkDatas.length <= 9) {
        this.showQrcode = true
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push({
            pointName:this.checkDatas[i].pointName,
            pointId:this.checkDatas[i].detailInfoDtos[0].pointId
          })
        }
        this.arry = arr
        // console.log(this.arry)
        this.qrcodeDatas = this.arry
        // this.ids = this.arry.toString()
        // let params = {
        //   ids: this.ids,
        //   page: '1',
        //   pageSize: '10000',
        //   orgId: this.storage.getSession("orgId"),
        //   zonename: ''
        // }
        // this.request.get('/patrolPointItem/qrgen', params).then(res => {
        //   console.log(res);
        //   if (res.code == 200) {
        //     this.qrcodeDatas = res.data
        //   } else if (res.code == 500) {
        //     this.msg.warn(res.msg)
        //   }
        // })
      } else if (this.checkDatas.length > 9) {
        this.msg.warn("最多选择9项内容！")
      }
    },
    closeQc(data) {
      this.showQrcode = data
    },
    handleSelectionChange(data) { //多选
      // console.log(data)
      this.checkDatas = data
    },
  }
};
</script>

<style lang="scss" scoped>
.patrolManagement {
  .query {
    margin-bottom: 20px;
  }

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }
  }
}
</style><style lang="scss">
.patrolManagement {
  .query {
    .el-input {
      width: 270px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }
  }
}
</style>
